/**
 * Seed data for the mock layer. Field names mirror KnoWledgeX/05-data-model.md
 * exactly, so replacing the mock with the Go API is a transport swap only.
 * Images come from free generators: picsum.photos (deterministic seeds) and
 * i.pravatar.cc (avatars) — no assets to host.
 */

export const img = (seed, w = 640, h = 360) => `https://picsum.photos/seed/kx-${seed}/${w}/${h}`
export const avatar = (seed) => `https://i.pravatar.cc/240?u=kx-${seed}`

const uid = (p, n) => `${p}-${String(n).padStart(4, '0')}`
const pick = (arr, i) => arr[i % arr.length]

/* ------------------------------------------------------------------ providers */
export const providers = [
  {
    id: uid('prv', 1), slug: 'KnoWledgeX', name: 'KnoWledgeX Academy',
    logo_url: img('logo-kx', 200, 200), cover_url: img('cover-kx', 1600, 500),
    description: 'Provider utama ekosistem The Muslim. Kurasi pakar terverifikasi lintas bidang.',
    website: 'https://KnoWledgeX.the-muslim.app', contact_email: 'hello@KnoWledgeX.app',
    is_active: true, is_verified: true, revenue_share_pct: 80, default_locale: 'id',
    instructor_count: 6, course_count: 11, student_count: 18420,
  },
  {
    id: uid('prv', 2), slug: 'baitul-hikmah', name: 'Baitul Hikmah Institute',
    logo_url: img('logo-bh', 200, 200), cover_url: img('cover-bh', 1600, 500),
    description: 'Lembaga kajian bahasa Arab & ulumul Qur’an, berdiri sejak 2011 di Bandung.',
    website: 'https://baitulhikmah.id', contact_email: 'admin@baitulhikmah.id',
    is_active: true, is_verified: true, revenue_share_pct: 75, default_locale: 'id',
    instructor_count: 4, course_count: 6, student_count: 7210,
  },
  {
    id: uid('prv', 3), slug: 'ihsan-wellbeing', name: 'Ihsan Wellbeing Center',
    logo_url: img('logo-iw', 200, 200), cover_url: img('cover-iw', 1600, 500),
    description: 'Klinik psikologi & konseling keluarga berbasis nilai Islam. Kuala Lumpur & Jakarta.',
    website: 'https://ihsanwellbeing.co', contact_email: 'care@ihsanwellbeing.co',
    is_active: true, is_verified: true, revenue_share_pct: 78, default_locale: 'ms',
    instructor_count: 3, course_count: 5, student_count: 4130,
  },
  {
    id: uid('prv', 4), slug: 'amanah-fintech-school', name: 'Amanah Fintech School',
    logo_url: img('logo-af', 200, 200), cover_url: img('cover-af', 1600, 500),
    description: 'Sekolah keuangan syariah praktis: sukuk, wakaf produktif, dan literasi investasi.',
    website: 'https://amanah.school', contact_email: 'team@amanah.school',
    is_active: true, is_verified: false, revenue_share_pct: 70, default_locale: 'id',
    instructor_count: 2, course_count: 4, student_count: 1980,
  },
]

/* ----------------------------------------------------------------- categories */
export const categories = [
  ['quran-recitation', 'Tahsin & Tilawah', 'Quran Recitation', 'Tahsin & Tilawah', 'تلاوة القرآن', 'auto_stories', '#1FA971'],
  ['arabic-language', 'Bahasa Arab Terapan', 'Applied Arabic', 'Bahasa Arab Gunaan', 'اللغة العربية', 'translate', '#2E7DF6'],
  ['fiqh-daily', 'Fikih Harian', 'Everyday Fiqh', 'Fiqah Harian', 'الفقه اليومي', 'balance', '#5C6BC0'],
  ['parenting', 'Parenting Nabawi', 'Prophetic Parenting', 'Keibubapaan', 'تربية الأبناء', 'child_care', '#EC407A'],
  ['mental-resilience', 'Ketahanan Mental', 'Mental Resilience', 'Ketahanan Mental', 'الصحة النفسية', 'psychology', '#7C4DFF'],
  ['halal-business', 'Bisnis Halal', 'Halal Business', 'Bisnes Halal', 'الأعمال الحلال', 'storefront', '#FFA726'],
  ['islamic-finance', 'Investasi Syariah', 'Sharia Investing', 'Pelaburan Syariah', 'الاستثمار الإسلامي', 'savings', '#26A69A'],
  ['data-ai', 'Data & AI Beretika', 'Ethical Data & AI', 'Data & AI', 'الذكاء الاصطناعي', 'memory', '#00ACC1'],
  ['nutrition-thibb', 'Gizi & Thibbun Nabawi', 'Nutrition & Prophetic Medicine', 'Nutrisi', 'التغذية', 'restaurant', '#7CB342'],
  ['marriage-prep', 'Persiapan Pernikahan', 'Marriage Prep', 'Persiapan Perkahwinan', 'الزواج', 'favorite', '#EF5350'],
  ['public-speaking', 'Dakwah & Public Speaking', 'Da’wah & Speaking', 'Dakwah & Pengucapan', 'الخطابة', 'campaign', '#F08A24'],
  ['hajj-umrah', 'Manasik Haji & Umrah', 'Hajj & Umrah Guide', 'Haji & Umrah', 'الحج والعمرة', 'mosque', '#8D6E63'],
  /* 30 bidang dari roster pakar nyata (lihat knowledgex-go
     internal/seed/data/pakar_categories.json). Sengaja diikutkan di mock:
     seluruh masalah tata letak yang diperbaiki — sidebar filter Catalog yang
     meluap, strip chip di beranda — hanya kelihatan pada skala 40+ kategori,
     dan build statis yang ter-deploy berjalan di atas mock ini.
     name_ar sengaja kosong: localized() jatuh ke name_id. */
  ['kaunseling', 'Konseling', 'Counselling', 'Kaunseling', '', 'self_improvement', '#7E57C2'],
  ['perubatan', 'Kedokteran', 'Medicine', 'Perubatan', '', 'medical_services', '#E53935'],
  ['perubatan-pediatrik', 'Kedokteran (Pediatri)', 'Medicine (Paediatrics)', 'Perubatan (Pediatrik)', '', 'crib', '#FF7043'],
  ['business-management-estate-planning-law', 'Bisnis & Manajemen / Hukum Perencanaan Harta', 'Business & Management / Estate Planning Law', 'Business & Management / Estate Planning Law', '', 'gavel', '#8D6E63'],
  ['kejuruteraan-elektrik-dan-elektronik', 'Teknik Elektro & Elektronika', 'Electrical & Electronic Engineering', 'Kejuruteraan Elektrik dan Elektronik', '', 'bolt', '#FBC02D'],
  ['perakaunan', 'Akuntansi', 'Accounting', 'Perakaunan', '', 'calculate', '#00897B'],
  ['management', 'Manajemen', 'Management', 'Management', '', 'corporate_fare', '#5C6BC0'],
  ['pemikiran-islam', 'Pemikiran Islam', 'Islamic Thought', 'Pemikiran Islam', '', 'menu_book', '#43A047'],
  ['kejuruteraan-elektrik-kuasa', 'Teknik Elektro (Tenaga)', 'Electrical Engineering (Power)', 'Kejuruteraan Elektrik (Kuasa)', '', 'electrical_services', '#F9A825'],
  ['tadbir-urus-korporat-pengurusan-risiko', 'Tata Kelola Korporat & Manajemen Risiko', 'Corporate Governance & Risk Management', 'Tadbir Urus Korporat & Pengurusan Risiko', '', 'shield', '#455A64'],
  ['project-management', 'Manajemen Proyek', 'Project Management', 'Project Management', '', 'checklist', '#3949AB'],
  ['psikologi-dalam-alquran-dan-alsunnah', 'Psikologi dalam Al-Qur\'an & As-Sunnah', 'Psychology in the Qur\'an & Sunnah', 'Psikologi Dalam AlQuran dan AlSunnah', '', 'neurology', '#9575CD'],
  ['pengajian-islam-perubatan-keluarga', 'Studi Islam & Kedokteran Keluarga', 'Islamic Studies & Family Medicine', 'Pengajian Islam & Perubatan Keluarga', '', 'family_restroom', '#26A69A'],
  ['pengimejan-diagnostik', 'Pencitraan Diagnostik', 'Diagnostic Imaging', 'Pengimejan Diagnostik', '', 'monitor_heart', '#EC407A'],
  ['pendidikan-balaghah-arab-al-quran', 'Pendidikan Balaghah Arab & Al-Qur\'an', 'Arabic & Qur\'anic Balaghah Education', 'Pendidikan Balaghah Arab & al-Quran', '', 'record_voice_over', '#1E88E5'],
  ['operations-management', 'Manajemen Operasi', 'Operations Management', 'Operations Management', '', 'precision_manufacturing', '#6D4C41'],
  ['bahasa-melayu', 'Bahasa Melayu', 'Malay Language', 'Bahasa Melayu', '', 'spellcheck', '#00ACC1'],
  ['tesl-technology-enhanced-language-learning', 'TESL & Pembelajaran Bahasa Berbasis Teknologi', 'TESL / Technology Enhanced Language Learning', 'TESL / Technology Enhanced Language Learning', '', 'cast_for_education', '#039BE5'],
  ['tafsir-al-quran', 'Tafsir Al-Qur\'an', 'Qur\'anic Exegesis', 'Tafsir al-Quran', '', 'import_contacts', '#2E7D32'],
  ['tesl', 'TESL (Pengajaran Bahasa Inggris)', 'TESL', 'TESL', '', 'language', '#0288D1'],
  ['structural-engineering-civil-engineering', 'Teknik Struktur & Teknik Sipil', 'Structural Engineering, Civil Engineering', 'Structural Engineering, Civil Engineering', '', 'architecture', '#546E7A'],
  ['syariah-islamic-law', 'Syariah & Hukum Islam', 'Shariah & Islamic Law', 'Syariah & Islamic Law', '', 'account_balance', '#1B5E20'],
  ['computer-in-education', 'Komputer dalam Pendidikan', 'Computer in Education', 'Computer in Education', '', 'computer', '#00838F'],
  ['perakaunan-islam', 'Akuntansi Syariah', 'Islamic Accounting', 'Perakaunan Islam', '', 'account_balance_wallet', '#00695C'],
  ['kajian-terjemahan', 'Kajian Penerjemahan', 'Translation Studies', 'Kajian Terjemahan', '', 'g_translate', '#5E35B1'],
  ['kejuruteraan-polimer', 'Teknik Polimer', 'Polymer Engineering', 'Kejuruteraan Polimer', '', 'science', '#7CB342'],
  ['pend-awal-kanak-kanak', 'Pendidikan Anak Usia Dini', 'Early Childhood Education', 'Pend Awal Kanak-Kanak', '', 'toys', '#FF8F00'],
  ['kejuruteraan-elektrik', 'Teknik Elektro', 'Electrical Engineering', 'Kejuruteraan Elektrik', '', 'power', '#FDD835'],
  ['kejuruteraan-kimia', 'Teknik Kimia', 'Chemical Engineering', 'Kejuruteraan Kimia', '', 'labs', '#8E24AA'],
  ['agribusiness-plantation-management', 'Agribisnis & Manajemen Perkebunan', 'Agribusiness / Plantation Management', 'Agribusiness / Plantation Management', '', 'agriculture', '#689F38'],
].map(([key, id_, en, ms, ar, icon, accent], i) => ({
  id: uid('cat', i + 1), key, name_id: id_, name_en: en, name_ms: ms, name_ar: ar,
  parent_id: null, icon, accent_color: accent, position: i + 1, is_active: true,
  course_count: 0,
}))

const catBy = (key) => categories.find((c) => c.key === key)

/* ---------------------------------------------------------------- instructors */
const rawInstructors = [
  ['Ustadz Bilal Hakim', 'Qari & pengajar tahsin, sanad Hafs an Ashim', 'quran-recitation', 1, true],
  ['Dr. Nayla Farhana', 'Psikolog klinis anak & remaja, M.Psi', 'mental-resilience', 3, true],
  ['Ustadzah Zahra Mumtaz', 'Dosen bahasa Arab, alumni Al-Azhar', 'arabic-language', 2, true],
  ['Dr. Iskandar Rahim', 'Konsultan keuangan syariah, CFP®', 'islamic-finance', 4, true],
  ['Ustadz Faris Abdillah', 'Peneliti fikih muamalah kontemporer', 'fiqh-daily', 1, true],
  ['Nadia Kusuma, M.Gz', 'Ahli gizi klinis & food-tech researcher', 'nutrition-thibb', 1, true],
  ['Dr. Haziq Rasyid', 'Data scientist, dosen etika AI', 'data-ai', 1, false],
  ['Ustadzah Rania Salsabila', 'Fasilitator parenting, 12 tahun praktik', 'parenting', 3, true],
  ['Ir. Tsaqif Maulana', 'Founder 2 UMKM halal, mentor bisnis', 'halal-business', 4, true],
  ['Ustadz Luthfi Anwar', 'Pembimbing manasik, 9x musim haji', 'hajj-umrah', 2, true],
  ['Dr. Salma Widuri', 'Konselor pranikah & terapis keluarga', 'marriage-prep', 3, true],
  ['Ustadz Ammar Syafiq', 'Trainer public speaking & khitabah', 'public-speaking', 2, false],
]

/**
 * A handful of experts imported from the real roster, kept at ZERO stats on
 * purpose. The 12 demo instructors above are fabricated with ratings of 4.4-4.9,
 * so without these nobody can see what a freshly onboarded expert looks like —
 * and every empty state added for them (no rating row, no slots, no courses)
 * would be untestable on the mock build that is actually deployed.
 *
 * Only a sample: duplicating all 32 here would mean maintaining the roster in
 * two places for no extra UI signal.
 */
const rawNewExperts = [
  ['Dr. Amnah Maktar', 'Kaunseling Kesihatan Mental · Kaunseling Integratif Barat & Islam', 'kaunseling',
    'Pegawai Psikologi (Kaunseling), Pejabat Kesihatan Daerah SPS, Pulau Pinang', 'Intervensi Kaunseling Integrasi Terapi Realiti–Tazkiyah Al-Nafs Terhadap Ihsan Kendiri Remaja'],
  ['Dr. Mohamad Najib Mat Pa', 'Pendidikan Perubatan · Perubatan Masyarakat', 'perubatan',
    'Pensyarah Perubatan, Pusat Pengajian Sains Perubatan, Universiti Sains Malaysia', 'Effectiveness of SmartShield Sexual Abuse Prevention in Primary School Children in Malaysia'],
  ['Ts. Dr. Mardhiyati Mohd Yunus', 'Radiomics · Digital Image Processing', 'pengimejan-diagnostik',
    'Pensyarah, Jabatan Diagnostik Perubatan, Fakulti Sains Kesihatan UNISEL', 'Pencirian Radiomik Imej Tomografi Berkomputer Angiografi Koronari'],
  ['Dr. Osinton Magansal', 'Pengurusan Ladang Kelapa Sawit · Smart Plantation', 'agribusiness-plantation-management',
    'Estates Senior Manager (Plantation Sector)', 'Strategic Improvement For The Implementation Of Knowledge Management Systems In Oil Palm Plantations'],
]

export const instructors = rawInstructors.map(([name, headline, catKey, prvIdx, verified], i) => ({
  id: uid('ins', i + 1),
  provider_id: providers[prvIdx - 1].id,
  name, headline,
  slug: name.toLowerCase().replace(/[^a-z\s]/g, '').trim().replace(/\s+/g, '-'),
  bio: `${name} telah mengajar lebih dari ${3 + (i % 12)} tahun di bidang ${headline.toLowerCase()}. Materinya menekankan praktik langsung, studi kasus nyata, dan rujukan yang bisa diverifikasi.`,
  avatar_url: avatar(i + 11),
  credentials: [
    { title: i % 2 ? 'Sertifikasi profesi terverifikasi' : 'Ijazah sanad terverifikasi', issuer: 'The Muslim Verification Team', year: 2019 + (i % 6) },
  ],
  category_id: catBy(catKey).id,
  social_links: { linkedin: 'https://linkedin.com', web: 'https://example.com' },
  is_verified: verified,
  rating_avg: +(4.4 + ((i * 7) % 6) / 10).toFixed(1),
  review_count: 120 + i * 47,
  student_count: 800 + i * 640,
  course_count: 2 + (i % 3),
  is_active: true,
  user_id: null,
})).concat(rawNewExperts.map(([name, headline, catKey, affiliation, thesis], i) => ({
  id: uid('ins', 100 + i + 1),
  provider_id: providers[0].id,
  name, headline,
  slug: name.toLowerCase().replace(/[^a-z\s]/g, '').trim().replace(/\s+/g, '-').replace(/^(ts-|dr-)+/, ''),
  bio: `${name} memiliki fokus kepakaran pada ${headline.replace(/ · /g, ' dan ')}. Disertasi doktoralnya berjudul “${thesis}”. Saat ini berkiprah sebagai ${affiliation}.`,
  avatar_url: `https://api.dicebear.com/9.x/initials/svg?seed=${encodeURIComponent(name)}`,
  credentials: [
    { title: 'Disertasi PhD', issuer: thesis, year: 0 },
    { title: 'Afiliasi', issuer: affiliation, year: 0 },
  ],
  category_id: catBy(catKey).id,
  social_links: {},
  // Verification is earned later (email confirmation / a complete profile), so
  // an import never grants it.
  is_verified: false,
  rating_avg: 0, review_count: 0, student_count: 0, course_count: 0,
  is_active: true,
  // Linked to the demo instructor login below, so /me/instructor resolves.
  user_id: i === 0 ? uid('usr', 90) : null,
})))

/* -------------------------------------------------------------------- courses */
const courseSeed = [
  ['Tahsin Bertahap: Dari Makhraj ke Tilawah Merdu', 'quran-recitation', 1, 'beginner', 149000, 0, 'id'],
  ['Tajwid Praktis untuk Imam Masjid', 'quran-recitation', 1, 'intermediate', 249000, 0, 'id'],
  ['Bahasa Arab Al-Qur’an dalam 40 Hari', 'arabic-language', 3, 'beginner', 0, 1, 'id'],
  ['Nahwu Terapan: Membaca Kitab Tanpa Harakat', 'arabic-language', 3, 'intermediate', 349000, 0, 'id'],
  ['Fikih Muamalah untuk Pekerja Kantoran', 'fiqh-daily', 5, 'all', 199000, 0, 'id'],
  ['Fikih Thaharah & Shalat Musafir', 'fiqh-daily', 5, 'beginner', 0, 1, 'id'],
  ['Parenting Nabawi 0–7 Tahun', 'parenting', 8, 'all', 279000, 0, 'id'],
  ['Menghadapi Anak Tantrum dengan Tenang', 'parenting', 8, 'beginner', 129000, 0, 'id'],
  ['Pulih dari Burnout: Pendekatan Islam & Klinis', 'mental-resilience', 2, 'all', 329000, 0, 'id'],
  ['Kecemasan Remaja: Panduan untuk Orang Tua', 'mental-resilience', 2, 'beginner', 189000, 0, 'ms'],
  ['Bangun UMKM Halal dari Rumah', 'halal-business', 9, 'beginner', 219000, 0, 'id'],
  ['Sertifikasi Halal: Langkah demi Langkah', 'halal-business', 9, 'intermediate', 399000, 0, 'id'],
  ['Investasi Syariah untuk Pemula', 'islamic-finance', 4, 'beginner', 159000, 0, 'id'],
  ['Wakaf Produktif & Perencanaan Warisan', 'islamic-finance', 4, 'expert', 549000, 0, 'id'],
  ['Etika AI: Panduan Praktisi Muslim', 'data-ai', 7, 'intermediate', 299000, 0, 'en'],
  ['Analisis Data untuk Pengelola Masjid', 'data-ai', 7, 'beginner', 0, 1, 'id'],
  ['Gizi Keluarga & Sunnah Makan', 'nutrition-thibb', 6, 'all', 169000, 0, 'id'],
  ['Meal Prep Sehat untuk Ibu Bekerja', 'nutrition-thibb', 6, 'beginner', 99000, 0, 'id'],
  ['Kelas Pranikah 8 Sesi', 'marriage-prep', 11, 'all', 449000, 0, 'id'],
  ['Komunikasi Suami-Istri yang Sehat', 'marriage-prep', 11, 'all', 199000, 0, 'ms'],
  ['Khitabah: Ceramah yang Didengar', 'public-speaking', 12, 'intermediate', 229000, 0, 'id'],
  ['Manasik Haji Mandiri', 'hajj-umrah', 10, 'all', 259000, 0, 'id'],
  ['Umrah Hemat & Tertib', 'hajj-umrah', 10, 'beginner', 0, 1, 'id'],
  ['Menulis Konten Dakwah di Media Sosial', 'public-speaking', 12, 'beginner', 119000, 0, 'id'],
]

const objectivesFor = (title) => [
  `Memahami fondasi ${title.split(':')[0].toLowerCase()} secara sistematis`,
  'Menerapkan materi lewat studi kasus & latihan terbimbing',
  'Menghindari 7 kesalahan paling umum pemula',
  'Menyusun rencana praktik 30 hari setelah kelas',
]

export const courses = courseSeed.map((s, i) => {
  const [title, catKey, insIdx, level, price, isFree, language] = s
  const ins = instructors[insIdx - 1]
  const cat = catBy(catKey)
  const n = i + 1
  const status = i === 4 ? 'pending_review' : i === 9 ? 'pending_review' : i === 15 ? 'draft' : i === 20 ? 'rejected' : 'published'
  return {
    id: uid('crs', n),
    provider_id: ins.provider_id,
    instructor_id: ins.id,
    category_id: cat.id,
    title,
    subtitle: 'Kelas terstruktur dengan latihan, kuis, dan sertifikat — dibimbing pakar terverifikasi.',
    slug: title.toLowerCase().replace(/[^a-z0-9\s]/g, '').trim().replace(/\s+/g, '-').slice(0, 60),
    description:
      '<p>Kelas ini disusun agar bisa diikuti sambil bekerja: setiap modul berisi video ringkas, catatan yang bisa diunduh, dan kuis pengecekan pemahaman.</p><p>Anda akan berlatih dengan contoh nyata, mendapat umpan balik lewat forum tanya-pakar, dan menutup kelas dengan proyek kecil yang bisa langsung dipakai.</p>',
    objectives: objectivesFor(title),
    requirements: ['Tidak perlu pengalaman sebelumnya', 'Siapkan buku catatan & 30 menit/hari', 'Koneksi internet untuk video HD'],
    target_audience: ['Pemula yang ingin belajar bertahap', 'Orang tua & pekerja dengan waktu terbatas', 'Pengurus komunitas/masjid'],
    thumbnail_url: img(`crs${n}`, 800, 450),
    promo_video_url: 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8',
    level, language,
    subtitle_langs: ['id', 'en', ...(i % 3 === 0 ? ['ms'] : []), ...(i % 4 === 0 ? ['ar'] : [])],
    tags: [cat.name_id, level, 'sertifikat'],
    status,
    rejected_reason: status === 'rejected' ? 'Audio modul 2 pecah di menit 04:12 — mohon rekam ulang.' : null,
    access_type: i % 7 === 0 ? 'expiry' : 'lifetime',
    access_days: i % 7 === 0 ? 365 : null,
    is_free: !!isFree,
    estimated_minutes: 180 + ((i * 37) % 420),
    certificate_enabled: true,
    completion_rule: { lessons_completed_pct: 100, quiz_passed: true },
    store_sku_ios: isFree ? null : `tier_${price / 1000}k_ios`,
    store_sku_android: isFree ? null : `tier_${price / 1000}k_and`,
    // `price`/`compare_at_price` RUPIAH dipertahankan sebagai warisan; yang
    // dipakai storefront adalah kolom kredit. Kurs 15.000 IDR = 1 kredit,
    // sama dengan seed.BackfillPriceCredits di sisi Go — kalau keduanya
    // berbeda, harga di mock dan di API sungguhan tidak akan pernah cocok
    // dan tiap kali orang membandingkannya akan mengira salah satunya bug.
    price, currency: 'IDR',
    compare_at_price: isFree ? null : Math.round((price * 1.6) / 10000) * 10000,
    price_credits: isFree ? 0 : Math.max(1, Math.round((price * 100) / 15000)),
    compare_at_credits: isFree ? 0 : Math.max(1, Math.round((price * 1.6 * 100) / 15000)),
    rating_avg: +(4.2 + ((i * 3) % 8) / 10).toFixed(1),
    review_count: 18 + ((i * 29) % 480),
    enroll_count: 120 + ((i * 313) % 5200),
    published_at: status === 'published' ? new Date(2025, i % 12, 3 + (i % 20)).toISOString() : null,
    created_at: new Date(2025, i % 11, 1 + (i % 25)).toISOString(),
    updated_at: new Date(2026, 6, 1 + (i % 28)).toISOString(),
  }
})

/* Nomor urut per pakar — cermin seed.BackfillCoursePositions di sisi Go.
 *
 * Diberikan di sini, bukan di dalam map di atas, karena nomornya dihitung PER
 * PAKAR: indeks `i` menghitung seluruh katalog, jadi memakainya akan memberi
 * pakar kedua nomor yang mulai dari 7. Urutannya sama dengan pemecah seri
 * terakhir orderCourses (created_at menurun), supaya urutan yang tampil di mock
 * dan di API sungguhan tidak berbeda. */
{
  const nomor = {}
  ;[...courses]
    .sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)) || a.id.localeCompare(b.id))
    .forEach((c) => {
      nomor[c.instructor_id] = (nomor[c.instructor_id] || 0) + 1
      c.position = nomor[c.instructor_id]
    })
}

/* Satu rantai prasyarat contoh, supaya kedua nada benar-benar bisa dilihat
 * saat meninjau desain: yang MENGUNCI (tombol beli diganti tautan) dan yang
 * cuma MENYARANKAN (tombol beli utuh). Tanpa data seperti ini, satu-satunya
 * tampilan yang pernah muncul di mock adalah "kelas tanpa prasyarat", yaitu
 * tampilan yang persis sama dengan fitur yang belum jalan. */
{
  const terbit = courses.filter((c) => c.status === 'published')
  const rantai = (anak, induk, wajib) => {
    if (!anak || !induk) return
    anak.prereq_course_id = induk.id
    anak.prereq_required = wajib
  }
  const seri = terbit.filter((c) => c.instructor_id === terbit[0]?.instructor_id)
  rantai(seri[1], seri[0], true)   // mengunci
  rantai(seri[2], seri[1], false)  // menyarankan
}

categories.forEach((c) => { c.course_count = courses.filter((x) => x.category_id === c.id && x.status === 'published').length })

/* ------------------------------------------------------- modules & lessons */
const lessonTitles = [
  ['Selamat datang & cara belajar di kelas ini', 'video', 420, true],
  ['Peta materi (unduh PDF)', 'pdf', null, true],
  ['Konsep inti dijelaskan sederhana', 'video', 760, false],
  ['Studi kasus: dari teori ke praktik', 'video', 980, false],
  ['Catatan ringkas & checklist', 'article', null, false],
  ['Kuis pengecekan pemahaman', 'quiz', null, false],
  ['Latihan terbimbing bagian 1', 'video', 1140, false],
  ['Latihan terbimbing bagian 2', 'video', 1020, false],
  ['Kesalahan umum & cara memperbaikinya', 'video', 640, false],
  ['Sesi tanya-jawab langsung', 'live', null, false],
  ['Proyek penutup & template', 'download', null, false],
  ['Kuis akhir & sertifikat', 'quiz', null, false],
]

export const modules = []
export const lessons = []
courses.forEach((c, ci) => {
  const moduleCount = 3 + (ci % 3)
  let lessonNo = 0
  for (let m = 0; m < moduleCount; m++) {
    const mid = uid('mod', modules.length + 1)
    modules.push({
      id: mid, course_id: c.id, position: m + 1,
      title: ['Fondasi', 'Praktik Inti', 'Penerapan Lanjutan', 'Proyek & Sertifikasi'][m] || `Modul ${m + 1}`,
      description: 'Ringkasan singkat apa yang dicapai di modul ini.',
      drip_type: m > 1 && ci % 5 === 0 ? 'days_after_enroll' : 'none',
      drip_days: m > 1 && ci % 5 === 0 ? m * 7 : null,
    })
    const per = 4
    for (let l = 0; l < per; l++) {
      const [title, type, dur, preview] = pick(lessonTitles, lessonNo)
      lessonNo++
      lessons.push({
        id: uid('les', lessons.length + 1),
        module_id: mid, course_id: c.id, title, type, position: l + 1,
        is_preview: preview && m === 0,
        duration_sec: dur,
        // Deskripsi diberikan ke SEMUA tipe, bukan cuma `article`. Halaman
        // belajar kini merender penjelasan pelajaran untuk tipe apa pun; kalau
        // mock hanya mengisinya untuk artikel, blok itu tidak pernah muncul di
        // build statis yang ter-deploy — yaitu tempat desainnya ditinjau.
        content_richtext: type === 'article'
          ? '<p>Catatan lengkap materi ini, bisa dibaca ulang kapan saja.</p><ul><li>Poin kunci 1</li><li>Poin kunci 2</li><li>Poin kunci 3</li></ul>'
          : '<p>Ringkasan singkat pelajaran ini dan apa yang perlu disiapkan sebelum mulai.</p>',
        quiz_id: type === 'quiz' ? uid('qz', lessons.length + 1) : null,
        // Bentuknya mengikuti server: `id` + `bytes`, bukan `size`. Kunci yang
        // berbeda antara mock dan API adalah cara paling halus membuat sebuah
        // fitur "jalan di mock, kosong di produksi".
        resources: l % 2 === 0
          ? [{ id: uid('res', lessons.length + 1), name: 'Ringkasan pelajaran.pdf', url: '#', bytes: 482000, mime: 'application/pdf' }]
          : [],
        is_published: true,
      })
    }
  }
})

/* ----------------------------------------------------------------- quizzes */
export const quizzes = lessons.filter((l) => l.type === 'quiz').map((l, i) => ({
  id: l.quiz_id, lesson_id: l.id, course_id: l.course_id,
  title: l.title, passing_score: 70, time_limit_sec: 600, max_attempts: 3,
  grading_method: 'highest', randomize_questions: true, randomize_options: true,
  show_correct: 'after_attempt', is_graded: true, required_to_pass: true,
  questions: [
    {
      id: `${l.quiz_id}-q1`, type: 'single_choice', points: 10,
      text: 'Mana pernyataan yang paling tepat tentang materi modul ini?',
      explanation: 'Jawaban benar menekankan praktik bertahap, bukan menghafal sekali jalan.',
      options: [
        { id: 'a', text: 'Cukup dihafal satu kali tanpa latihan', is_correct: false },
        { id: 'b', text: 'Dipraktikkan bertahap dengan koreksi berkala', is_correct: true },
        { id: 'c', text: 'Hanya berlaku untuk kalangan tertentu', is_correct: false },
        { id: 'd', text: 'Tidak perlu rujukan sumber', is_correct: false },
      ],
    },
    {
      id: `${l.quiz_id}-q2`, type: 'multi_select', points: 10,
      text: 'Pilih dua kebiasaan yang membantu konsistensi belajar.',
      explanation: 'Jadwal tetap dan catatan ringkas terbukti paling berpengaruh.',
      options: [
        { id: 'a', text: 'Jadwal tetap 30 menit/hari', is_correct: true },
        { id: 'b', text: 'Menonton semua video dalam satu malam', is_correct: false },
        { id: 'c', text: 'Membuat catatan ringkas tiap sesi', is_correct: true },
        { id: 'd', text: 'Melewati kuis agar cepat selesai', is_correct: false },
      ],
    },
    {
      id: `${l.quiz_id}-q3`, type: 'true_false', points: 5,
      text: 'Sertifikat terbit otomatis setelah semua lesson selesai dan kuis akhir lulus.',
      explanation: 'Benar — sesuai completion rule kelas ini.',
      options: [{ id: 't', text: 'Benar', is_correct: true }, { id: 'f', text: 'Salah', is_correct: false }],
    },
  ],
}))

/* ------------------------------------------------------------- live classes */
const liveTitles = [
  'Bedah Kasus: Anak Sulit Fokus Belajar',
  'Tanya Jawab Zakat Profesi & Investasi',
  'Latihan Tilawah Bersama (Halaqah Online)',
  'Menyusun Rencana Keuangan Keluarga 2027',
  'Workshop: Menyiapkan Sertifikasi Halal',
  'Sesi Terbuka: Kesehatan Mental Pekerja',
]
export const liveClasses = liveTitles.map((title, i) => {
  const ins = instructors[(i * 2) % instructors.length]
  const base = Date.now() + (i - 1) * 36e5 * 20
  return {
    id: uid('liv', i + 1), provider_id: ins.provider_id, instructor_id: ins.id,
    course_id: i % 2 ? courses[i].id : null,
    title, description: 'Sesi langsung 90 menit dengan tanya-jawab terbuka di akhir.',
    thumbnail_url: img(`liv${i}`, 800, 450), room: `room-${i + 1}`,
    status: i === 0 ? 'live' : i === 1 ? 'scheduled' : i === 5 ? 'ended' : 'scheduled',
    scheduled_at: new Date(base).toISOString(),
    duration_min: 90,
    is_free: i % 3 === 0, price: i % 3 === 0 ? 0 : 75000,
    price_credits: i % 3 === 0 ? 0 : 500,
    viewer_count: i === 0 ? 312 : 0, peak_viewers: i === 5 ? 780 : 0,
    reminded: false,
  }
})

/* --------------------------------------------------------------------- Q&A */
export const qaQuestions = [
  ['Bagaimana hukum bonus tahunan dari perusahaan konvensional?', 'fiqh-daily', 5, 'answered', 'Selama akad kerja dan sumber pendapatan utamanya halal, bonus tersebut halal. Yang perlu diperhatikan adalah bila komponen bonus berasal langsung dari unit bisnis riba — porsi itu sebaiknya disalurkan sebagai sedekah, bukan dikonsumsi.'],
  ['Anak saya 5 tahun belum lancar hafalan, apakah normal?', 'parenting', 8, 'answered', 'Sangat normal. Pada usia itu prioritasnya adalah kelekatan positif dengan Al-Qur’an, bukan target jumlah. Buat sesi pendek 5–7 menit, konsisten, dan selalu tutup dengan pujian.'],
  ['Bolehkah membaca Al-Qur’an dari aplikasi saat haid?', 'quran-recitation', 1, 'answered', 'Mayoritas ulama kontemporer membolehkan membaca dari layar tanpa menyentuh mushaf fisik. Pendapat ini dipakai luas untuk kebutuhan belajar dan menjaga hafalan.'],
  ['Cara memulai investasi syariah dengan modal Rp500 ribu?', 'islamic-finance', 4, 'open', null],
  ['Apakah terapi CBT sesuai dengan pandangan Islam?', 'mental-resilience', 2, 'answered', 'CBT adalah metode, bukan ideologi. Selama tekniknya tidak bertabrakan dengan akidah dan tujuan terapinya jelas, ia bisa dipakai dan sering dikombinasikan dengan pendekatan spiritual.'],
  ['Bagaimana menjelaskan wakaf produktif ke keluarga besar?', 'islamic-finance', 4, 'open', null],
  ['Adab bertanya kepada pakar yang berbeda pendapat?', 'fiqh-daily', 5, 'answered', 'Tanyakan dasar dan konteks pendapatnya, bukan mencari pembenaran. Perbedaan pendapat yang berdalil adalah rahmat, bukan alasan saling menyalahkan.'],
  ['Menu MPASI sesuai sunnah untuk bayi 8 bulan?', 'nutrition-thibb', 6, 'open', null],
].map(([title, catKey, insIdx, status, answer], i) => ({
  id: uid('qa', i + 1),
  provider_id: instructors[insIdx - 1].provider_id,
  user_id: uid('usr', 1 + (i % 4)),
  user_name: ['Ahmad R.', 'Siti Kholifah', 'Firdaus', 'Aisyah N.'][i % 4],
  category_id: catBy(catKey).id,
  instructor_id: instructors[insIdx - 1].id,
  title,
  body: 'Assalamu’alaikum ustadz/ustadzah, mohon penjelasannya. Saya sudah mencari di internet tapi jawabannya saling bertentangan, jadi ingin rujukan yang bisa dipertanggungjawabkan.',
  status, is_public: true,
  vote_count: 3 + ((i * 11) % 40),
  created_at: new Date(Date.now() - (i + 1) * 864e5 * 2).toISOString(),
  answers: answer ? [{
    id: uid('qaa', i + 1), instructor_id: instructors[insIdx - 1].id,
    body: answer, created_at: new Date(Date.now() - (i + 1) * 864e5).toISOString(),
  }] : [],
}))

/* ------------------------------------------------- consultation slots */
export const consultationSlots = []
instructors.slice(0, 8).forEach((ins, i) => {
  for (let d = 1; d <= 6; d++) {
    for (let h = 0; h < 3; h++) {
      const start = new Date(); start.setDate(start.getDate() + d); start.setHours(9 + h * 3, 0, 0, 0)
      consultationSlots.push({
        id: uid('slt', consultationSlots.length + 1),
        instructor_id: ins.id, provider_id: ins.provider_id,
        start_at: start.toISOString(), duration_min: h === 1 ? 60 : 30,
        price: (h === 1 ? 350000 : 200000) + i * 25000,
        price_credits: Math.round((((h === 1 ? 350000 : 200000) + i * 25000) * 100) / 15000),
        is_booked: (d + h + i) % 5 === 0, status: 'open',
      })
    }
  }
})

/* ------------------------------------------------------------------ users */
export const users = [
  {
    id: uid('usr', 1), muslim_sub: 'muslim|8f21', name: 'Ahmad Ridwan',
    email: 'ahmad.ridwan@example.com', avatar_url: avatar(2), locale: 'id',
    role: 'student', joined_at: '2025-03-11T04:00:00Z',
  },
  {
    id: uid('adm', 1), muslim_sub: 'muslim|admin1', name: 'Nurul Fatimah',
    email: 'nurul@KnoWledgeX.app', avatar_url: avatar(5), locale: 'id',
    role: 'platform_admin', provider_id: null, joined_at: '2024-08-02T04:00:00Z',
    permissions: ['academy.*'],
  },
  {
    id: uid('adm', 2), muslim_sub: 'muslim|prv2', name: 'Yusuf Maulana',
    email: 'yusuf@baitulhikmah.id', avatar_url: avatar(9), locale: 'id',
    role: 'provider_admin', provider_id: providers[1].id, joined_at: '2025-01-20T04:00:00Z',
    permissions: ['academy.course.*', 'academy.instructor.*', 'academy.earning.view'],
  },
  {
    // Demo login for the `instructor` role — without it /me/instructor has no
    // account to resolve and the profile page cannot be exercised on the mock.
    id: uid('usr', 90), muslim_sub: 'pakar:pkr-001', name: 'Dr. Amnah Maktar',
    email: 'amnahmaktar@gmail.com',
    avatar_url: 'https://api.dicebear.com/9.x/initials/svg?seed=Dr.%20Amnah%20Maktar',
    locale: 'ms', role: 'instructor', provider_id: providers[0].id,
    joined_at: '2026-08-01T04:00:00Z',
    permissions: ['academy.instructor.profile.read', 'academy.instructor.profile.write'],
  },
]

/* ------------------------------------------- enrollments, orders, ledger */
const enrolledIdx = [0, 2, 6, 12, 16, 18]
export const enrollments = enrolledIdx.map((ci, i) => {
  const c = courses[ci]
  const pct = [64, 100, 12, 38, 100, 5][i]
  return {
    id: uid('enr', i + 1), user_id: users[0].id, course_id: c.id,
    source: c.is_free ? 'free' : 'purchase',
    order_id: c.is_free ? null : uid('ord', i + 1),
    enrolled_at: new Date(Date.now() - (i + 2) * 864e5 * 9).toISOString(),
    expires_at: null,
    started_at: new Date(Date.now() - (i + 1) * 864e5 * 7).toISOString(),
    completed_at: pct === 100 ? new Date(Date.now() - i * 864e5 * 3).toISOString() : null,
    percent_complete: pct,
    status: pct === 100 ? 'completed' : 'active',
    certificate_id: pct === 100 ? uid('cer', i + 1) : null,
    last_lesson_id: lessons.find((l) => l.course_id === c.id).id,
  }
})

// Penghitung provider DIHITUNG, bukan diketik. Angka literal di definisi
// provider di atas (`course_count: 11, student_count: 18420`) adalah sisa data
// demo dan tidak pernah cocok dengan katalog — persis bug yang baru diperbaiki
// di Go (`providerCounts`, internal/api/catalog.go). Mock adalah spec runtime
// de-facto (CLAUDE.md §4): kalau di sini angkanya masih dikarang, bug yang sama
// akan terlihat "benar" saat VITE_USE_MOCK=true dan tidak ada yang menyadarinya.
//
// Ditempatkan di sini, setelah `enrollments`, bukan di dekat definisi provider:
// student_count butuh enrollments, dan menghitungnya sebelum array itu ada
// menghasilkan 0 secara diam-diam, bukan error.
providers.forEach((p) => {
  const own = courses.filter((c) => c.provider_id === p.id && c.status === 'published')
  const ids = new Set(own.map((c) => c.id))
  p.course_count = own.length
  p.instructor_count = instructors.filter((i) => i.provider_id === p.id && i.is_active !== false).length
  // Orang yang berbeda, bukan jumlah baris pendaftaran — sama seperti DISTINCT di Go.
  p.student_count = new Set(enrollments.filter((e) => ids.has(e.course_id)).map((e) => e.user_id)).size
})

export const lessonProgress = []
enrollments.forEach((e) => {
  const ls = lessons.filter((l) => l.course_id === e.course_id)
  const done = Math.round((ls.length * e.percent_complete) / 100)
  ls.forEach((l, i) => {
    lessonProgress.push({
      id: uid('lpr', lessonProgress.length + 1), enrollment_id: e.id, lesson_id: l.id, user_id: e.user_id,
      last_position_sec: i < done ? l.duration_sec || 0 : i === done ? Math.round((l.duration_sec || 0) * 0.35) : 0,
      seconds_watched: i < done ? l.duration_sec || 0 : 0,
      percent_watched: i < done ? 100 : i === done ? 35 : 0,
      completed: i < done, completed_at: i < done ? new Date().toISOString() : null,
    })
  })
})

export const orders = enrollments.filter((e) => e.order_id).map((e, i) => {
  const c = courses.find((x) => x.id === e.course_id)
  return {
    // Pesanan mock berdenominasi KREDIT, sama dengan pesanan sungguhan yang
    // dibuat sejak dompet kredit ada. Kolom rupiah warisan (`gross_amount`,
    // `subtotal`) sengaja diisi 0: itulah yang benar-benar tersimpan untuk
    // pesanan kredit di database, dan mock yang mengisinya dengan angka wajar
    // akan menyembunyikan tepat satu kelas bug — halaman yang masih membaca
    // kolom lama akan terlihat benar di mock lalu menampilkan nol di produksi.
    id: e.order_id, user_id: e.user_id, provider_id: c.provider_id, course_id: c.id, currency: 'CREDIT',
    subtotal: 0, discount_total: i === 0 ? 200 : 0, tax_total: 0,
    gross_amount: 0,
    credits_total: Math.max(0, (c.price_credits || 0) - (i === 0 ? 200 : 0)),
    coupon_id: i === 0 ? uid('cpn', 1) : null,
    gateway: 'credits',
    gateway_order_id: `KX-${2026}${String(i + 1).padStart(5, '0')}`,
    gateway_txn_id: `txn-${Math.random().toString(36).slice(2, 10)}`,
    status: 'paid', paid_at: e.enrolled_at,
    lines: [{ kind: 'course', target_id: c.id, title_snapshot: c.title, price_snapshot_credits: c.price_credits, qty: 1 }],
    attribution_channel: i === 0 ? 'coupon' : 'organic',
  }
})

export const coupons = [
  { id: uid('cpn', 1), provider_id: null, code: 'BELAJAR30', type: 'fixed', value: 30000, value_credits: 200, scope: 'global', max_uses: 500, uses_count: 143, per_user_limit: 1, starts_at: '2026-06-01', ends_at: '2026-12-31', is_active: true },
  { id: uid('cpn', 2), provider_id: providers[1].id, code: 'HIKMAH20', type: 'percent', value: 20, value_credits: 0, scope: 'course', max_uses: 200, uses_count: 58, per_user_limit: 1, starts_at: '2026-07-01', ends_at: '2026-09-30', is_active: true },
  { id: uid('cpn', 3), provider_id: null, code: 'RAMADAN50', type: 'percent', value: 50, value_credits: 0, scope: 'global', max_uses: 1000, uses_count: 1000, per_user_limit: 1, starts_at: '2026-02-01', ends_at: '2026-03-30', is_active: false },
]

export const priceTiers = [0, 99000, 129000, 149000, 199000, 249000, 299000, 349000, 449000, 549000].map((amount, i) => ({
  id: uid('tir', i + 1), key: amount === 0 ? 'free' : `tier_${amount / 1000}k`, amount, currency: 'IDR',
  sku_ios: amount === 0 ? null : `kx.tier.${amount / 1000}k`, sku_android: amount === 0 ? null : `kx_tier_${amount / 1000}k`,
  is_active: true, course_count: courses.filter((c) => c.price === amount).length,
}))

export const reviews = []
courses.forEach((c, ci) => {
  const names = ['Ahmad R.', 'Siti Kholifah', 'Firdaus H.', 'Aisyah N.', 'Rizal P.', 'Maryam S.']
  const texts = [
    'Penjelasannya runtut dan tidak bertele-tele. Bagian latihan paling membantu.',
    'Materi bagus, tapi audio modul 3 agak pelan. Sisanya mantap.',
    'Baru selesai 2 modul dan sudah kepakai di rumah. Alhamdulillah.',
    'Sertifikatnya rapi dan bisa diverifikasi, jadi nilai tambah untuk kerja.',
    'Ustadznya sabar menjawab di forum. Worth it.',
  ]
  for (let i = 0; i < 3 + (ci % 3); i++) {
    reviews.push({
      id: uid('rev', reviews.length + 1), course_id: c.id, course_title: c.title,
      user_id: uid('usr', 1 + (i % 4)), user_name: pick(names, ci + i), user_avatar: avatar(30 + ci + i),
      stars: [5, 5, 4, 5, 3, 4][(ci + i) % 6], text: pick(texts, ci + i),
      instructor_response: i === 0 && ci % 4 === 0 ? 'Terima kasih masukannya, audio modul 3 sudah kami rekam ulang.' : null,
      helpful_count: (ci * 3 + i) % 24, status: (ci + i) % 11 === 0 ? 'hidden' : 'published',
      created_at: new Date(Date.now() - (ci + i + 1) * 864e5 * 3).toISOString(),
    })
  }
})

export const certificates = enrollments.filter((e) => e.certificate_id).map((e, i) => {
  const c = courses.find((x) => x.id === e.course_id)
  return {
    id: e.certificate_id, serial_number: `KX-2026-${String(1042 + i)}`,
    verification_code: `KX${(1042 + i).toString(36).toUpperCase()}9F${i}`,
    user_id: e.user_id, user_name: users[0].name, course_id: c.id, course_title: c.title,
    provider_name: providers.find((p) => p.id === c.provider_id).name,
    instructor_name: instructors.find((x) => x.id === c.instructor_id).name,
    enrollment_id: e.id, issued_at: e.completed_at, completion_date: e.completed_at,
    hours: Math.round(c.estimated_minutes / 60), final_score: 88 + i * 3,
    pdf_url: '#', status: 'issued',
  }
})

export const bookings = [
  { id: uid('bkg', 1), slot_id: consultationSlots[1].id, user_id: users[0].id, instructor_id: consultationSlots[1].instructor_id, status: 'confirmed', order_id: null, room: 'room-c1', notes: 'Konsultasi soal pola tidur anak.', created_at: new Date().toISOString() },
  { id: uid('bkg', 2), slot_id: consultationSlots[20].id, user_id: users[0].id, instructor_id: consultationSlots[20].instructor_id, status: 'done', order_id: null, room: 'room-c2', notes: 'Review rencana keuangan.', created_at: new Date(Date.now() - 864e5 * 14).toISOString() },
]

/**
 * Buku besar bagi hasil: SATU BARIS PER PENERIMA, bukan satu baris per pesanan.
 *
 * Bentuk lama (satu baris berisi gross/channel_fee/platform_fee/net_provider)
 * berasal dari masa ketika uangnya rupiah dan yang dibayar cuma provider. Sejak
 * pembagian jadi empat pihak, bentuk itu tidak bisa menampung jawabannya sama
 * sekali — dan halaman Pendapatan yang masih membacanya menampilkan Rp 0 di
 * setiap kolom sementara ledger sungguhannya berisi angka.
 *
 * Sisa pembulatan jatuh ke platform, sama dengan aturan di internal/api/split.go.
 * Kalau di sini dibagi rata atau dibulatkan naik, jumlah keempat baris tidak
 * lagi sama dengan nilai pesanannya, dan mock berhenti bisa dipakai untuk
 * memeriksa apakah tampilan totalnya benar.
 */
export const earnings = orders.flatMap((o, i) => {
  const c = courses.find((x) => x.id === o.course_id) || courses[i % courses.length]
  const ins = instructors.find((x) => x.id === c.instructor_id)
  const gross = o.credits_total
  const bagian = (pct) => Math.floor((gross * pct) / 100)
  const provider = bagian(30)
  const instructor = bagian(30)
  const affiliate = 0 // pesanan demo tidak punya afiliator
  const platform = gross - provider - instructor - affiliate // sisa jatuh ke sini
  const status = i < 2 ? 'payable' : i === 2 ? 'held' : 'paid'
  const dasar = {
    order_id: o.id, course_id: c.id, provider_id: o.provider_id,
    provider_name: providers.find((p) => p.id === o.provider_id).name,
    status, available_at: new Date(Date.now() + 864e5 * 30).toISOString(),
    created_at: o.paid_at, withdrawal_id: null,
    // Kolom rupiah warisan. Dipertahankan karena masih ada di JSON sungguhan,
    // dan sengaja 0 — persis seperti baris yang ditulis jalur kredit.
    gross: 0, channel_fee: 0, platform_fee: 0, tax: 0, net_provider: 0,
  }
  return [
    { ...dasar, id: uid('ern', i * 4 + 1), payee_type: 'platform', payee_id: '', payee_name: 'The Muslim', credits: platform, share_pct: 20, status: 'settled' },
    { ...dasar, id: uid('ern', i * 4 + 2), payee_type: 'provider', payee_id: o.provider_id, payee_name: dasar.provider_name, credits: provider, share_pct: 30 },
    { ...dasar, id: uid('ern', i * 4 + 3), payee_type: 'instructor', payee_id: ins?.id || '', payee_name: ins?.name || '', credits: instructor, share_pct: 30 },
    { ...dasar, id: uid('ern', i * 4 + 4), payee_type: 'affiliate', payee_id: '', payee_name: '', credits: affiliate, share_pct: 20, status: 'unclaimed' },
  ]
})

export const payouts = providers.map((p, i) => ({
  id: uid('pay', i + 1), provider_id: p.id, provider_name: p.name,
  period_start: '2026-07-01', period_end: '2026-07-31',
  total_amount: 4_200_000 + i * 3_150_000, currency: 'IDR',
  status: ['paid', 'processing', 'pending', 'pending'][i], method: 'bank_transfer',
  paid_at: i === 0 ? '2026-08-02T03:00:00Z' : null,
}))

export const notifications = [
  { id: 'ntf-1', kind: 'liveclass_started', title: 'Kelas langsung dimulai', body: 'Bedah Kasus: Anak Sulit Fokus Belajar sedang berlangsung.', created_at: new Date(Date.now() - 6e5).toISOString(), read_at: null },
  { id: 'ntf-2', kind: 'qa_answered', title: 'Pertanyaan Anda dijawab', body: 'Ustadz Faris Abdillah menjawab pertanyaan tentang bonus tahunan.', created_at: new Date(Date.now() - 864e5).toISOString(), read_at: null },
  { id: 'ntf-3', kind: 'certificate_issued', title: 'Sertifikat terbit', body: 'Sertifikat Bahasa Arab Al-Qur’an dalam 40 Hari sudah bisa diunduh.', created_at: new Date(Date.now() - 864e5 * 3).toISOString(), read_at: new Date().toISOString() },
]

/**
 * Bentuknya mengikuti /admin/dashboard yang asli (internal/api/dashboard.go).
 *
 * Angkanya tetap karangan — memang itu gunanya mock. Yang PENTING adalah
 * BENTUKNYA sama persis dengan API sungguhan: `health` sebagai daftar (bukan
 * empat kunci lepas), `credits_series` dalam satuan 1/100 kredit penuh, dan
 * `funnel_conversion` yang dikirim terpisah. Kalau bentuknya menyimpang, mock
 * berhenti berguna sebagai pengganti dan malah menyembunyikan kesalahan.
 *
 * Perhatikan tidak ada lagi `refund_rate`: sistem ini tidak punya konsep refund
 * di mana pun, jadi mock pun tidak boleh berpura-pura punya.
 */
export const dashboardStats = {
  period_label: 'Agustus 2026',
  // Satuan KREDIT (1/100 kredit), bukan rupiah — dan namanya ikut berubah.
  // Kunci lama `gmv_month` sengaja TIDAK dipertahankan sebagai alias: klien
  // yang masih membacanya harus kehilangan field-nya dan menampilkan kosong,
  // bukan menerima 1.842.500 lalu merendernya "Rp 1.842.500".
  credit_scale: 100,
  credits_month: 1_842_500,
  credits_delta: 12.4,
  enrollments_month: 1_284,
  enrollments_delta: 8.1,
  lessons_completed_month: 18_942,
  lessons_delta: 15.7,
  certificates_month: 412,
  certificates_delta: -3.2,
  health: [
    { label: 'Kelas terbit', value: String(courses.filter((c) => c.status === 'published').length), icon: 'video_library' },
    { label: 'Pakar terverifikasi', value: String(instructors.filter((i) => i.is_verified).length), icon: 'verified' },
    { label: 'Rating rata-rata', value: '4,6', icon: 'star' },
    { label: 'Provider aktif', value: String(providers.filter((p) => p.is_active).length), icon: 'apartment' },
  ],
  credits_series: [92, 104, 98, 121, 133, 128, 149, 156, 151, 168, 175, 185]
    .map((v, i) => ({ label: ['Sep', 'Okt', 'Nov', 'Des', 'Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu'][i], value: v * 10_000 })),
  funnel: [
    { label: 'Kunjungan katalog', value: 42_800 },
    { label: 'Lihat detail kelas', value: 12_400 },
    { label: 'Mulai checkout', value: 3_120 },
    { label: 'Bayar berhasil', value: 1_284 },
  ],
  funnel_conversion: 3.0,
  top_courses: courses.slice(0, 5).map((c, i) => ({ id: c.id, title: c.title, enrolls: 620 - i * 84, revenue_credits: (620 - i * 84) * (c.price_credits || 0) })),
}
